import React from 'react';
import classnames from 'classnames';

import './index.css';

export const Form = ({className, ...rest}) => <form {...rest} className={classnames('form', className)} />;

export const Form1 = (props) => <Form {...props} className={'form_1'} />;
export const Form2 = (props) => <Form {...props} className={'form_2'} />;
